import { createRoiScheme, readRoiScheme, droiScheme } from './roiSchemeHandler';
import { get, CleanSchema } from '../../../json-transform';
import { EVENT_POLICY_TRIGGER_OPTIONS, IMAGE_FORMAT_OPTIONS, SENDING_TYPE_OPTIONS } from '../../constants';

export const createBagsAnalytic = new CleanSchema({
  analytic_name: get('analytic_name'),
  parameters: {
    parameters: {
      bag_confidence_trh: get('parameters.parameters.bag_confidence_trh').asFloat().ifNaN(undefined),
      area_trh: get('parameters.parameters.area_trh').asInt().ifNaN(undefined),
      min_lenght_lost: get('parameters.parameters.min_lenght_lost').asInt().ifNaN(undefined),
      iou_static_trh: get('parameters.parameters.iou_static_trh').asFloat().ifNaN(undefined),
      human_bbox_expand_coeff: get('parameters.parameters.human_bbox_expand_coeff').asFloat().ifNaN(undefined),
      human_intersection_num_frames_trh: get('parameters.parameters.human_intersection_num_frames_trh').asInt().ifNaN(undefined),
      human_intersection_new_range_trh: get('parameters.parameters.human_intersection_new_range_trh').asInt().ifNaN(undefined),
      event_policy: {
        trigger: get('parameters.parameters.event_policy.trigger').asOptionValue(),
        interval: get('parameters.parameters.event_policy.interval').asFloat().ifNaN(undefined),
      },
      image_retain_policy: {
        mimetype: get('parameters.parameters.image_retain_policy.mimetype').asOptionValue(),
        quality: get('parameters.parameters.image_retain_policy.quality').asFloat().ifNaN(undefined),
        max_size: get('parameters.parameters.image_retain_policy.max_size').asInt().ifNaN(undefined),
      },
      rate: {
        unit: get('parameters.parameters.rate.unit').asOptionValue(),
        period: get('parameters.parameters.rate.period').asFloat().ifNaN(undefined),
      },
      roi: get('parameters.parameters.roi').as(createRoiScheme),
      droi: get('parameters.parameters.droi').as(droiScheme),
    },
    targets: get('parameters.targets'),
    callbacks: get('parameters.callbacks').asArrayOf(),
  },
});

export const readBagsAnalytic = new CleanSchema({
  analytic_name: get('analytic_name'),
  parameters: {
    parameters: {
      bag_confidence_trh: get('parameters.parameters.bag_confidence_trh'),
      area_trh: get('parameters.parameters.area_trh'),
      min_lenght_lost: get('parameters.parameters.min_lenght_lost'),
      event_policy: {
        trigger: get('parameters.parameters.event_policy.trigger').asOption(EVENT_POLICY_TRIGGER_OPTIONS),
        interval: get('parameters.parameters.event_policy.interval'),
      },
      image_retain_policy: {
        mimetype: get('parameters.parameters.image_retain_policy.mimetype').asOption(IMAGE_FORMAT_OPTIONS),
        quality: get('parameters.parameters.image_retain_policy.quality'),
        max_size: get('parameters.parameters.image_retain_policy.max_size'),
      },
      rate: {
        unit: get('parameters.parameters.rate.unit').asOption(SENDING_TYPE_OPTIONS),
        period: get('parameters.parameters.rate.period'),
      },
      roi: get('parameters.parameters.roi').as(readRoiScheme),
      droi: get('parameters.parameters.droi').as(droiScheme),
      iou_static_trh: get('parameters.parameters.iou_static_trh'),
      human_bbox_expand_coeff: get('parameters.parameters.human_bbox_expand_coeff'),
      human_intersection_num_frames_trh: get('parameters.parameters.human_intersection_num_frames_trh'),
      human_intersection_new_range_trh: get('parameters.parameters.human_intersection_new_range_trh'),
    },
    targets: get('parameters.targets'),
    callbacks: get('parameters.callbacks').asArrayOf(),
  },
  status: get('status'),
  autorestart: get('autorestart'),
});
